import { graphql } from "@/graphql";

export const businessUnitUsersQuery = graphql(`
  query BusinessUnitUsers($businessUnitId: Int) {
    businessUnitUsers(businessUnitId: $businessUnitId) {
      id
      status
      isOrganisationOwner
      role {
        id
        name
      }
      user {
        id
        firstName
        lastName
        email
        jobTitle
        isStaff
        lastLogin
        dateJoined
        image
      }
    }
  }
`);

export const rolesListQuery = graphql(`
  query RolesList {
    roles {
      id
      name
    }
  }
`);
